import { TCssColor } from '@cian/ui-kit/prev/types';

export const COLOR_MAPPER = {
  black: { color: '152242' as TCssColor },
  white: { color: 'FFFFFF' as TCssColor },
  gray: { color: '7A7A7A' as TCssColor },
  blue: { color: '2B87DB' as TCssColor },
};
